import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";

declare var ko: any;

export class newsletterInteractionEmailList_template extends vnTemplate {

    //As VM
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filter: filterSimple_template;

    protected getTemplateHtml(): string {
        return (`
        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd},  visible: permissions()['newsletter_interaction_emails'].read" class="btn secondary icon i-add" type="button">Create Interaction Email</button>    
            </div>
            <div class="w-center" >
                ` + this.filter.getHtmlBuild() + `
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>
        
        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Reference</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subject') }, css: { 'list-sort-desc': orderByAndDirection()=='subject_DESC', 'list-sort-asc': orderByAndDirection()=='subject_ASC' }">Subject</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'eventReference') }, css: { 'list-sort-desc': orderByAndDirection()=='eventReference_DESC', 'list-sort-asc': orderByAndDirection()=='eventReference_ASC' }">Event</span></th>
                            <th>Status</th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'eventSchedule') }, css: { 'list-sort-desc': orderByAndDirection()=='eventSchedule_DESC', 'list-sort-asc': orderByAndDirection()=='eventSchedule_ASC' }">Scheduled</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template') }, css: { 'list-sort-desc': orderByAndDirection()=='template_DESC', 'list-sort-asc': orderByAndDirection()=='template_ASC' }">Template</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Creation Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Update Date</span></th>
                            </tr>
                    </thead>
                    <tbody data-bind="foreach: newsletterInteractionEmails">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewNewsletterInteractionEmail } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="if: subject, event: { click: $parent.viewNewsletterInteractionEmail }"><a class="right-click" data-bind="attr: { href : emakiView }"><div class="flex"><span data-bind="text: subject"></span></div></a></td>
                            <td data-bind="event: { click: $parent.viewNewsletterInteractionEmail }"><a class="right-click" data-bind="attr: { href : emakiView }"><div class="flex"><span data-bind="text: eventName"></span></div></a></td>
                            <td><div class="interaction-email-status"><span data-bind="text: statusLabel"></span><!-- ko if: isActive --><a class="interaction-email-deactivate-link" href="#" data-bind="event: { click: $parent.onClickDeactivate }">Deactivate</a><!-- /ko --></div></td>
                            <td data-bind="event: { click: $parent.viewNewsletterInteractionEmail }"><a class="right-click" data-bind="attr: { href : emakiView }"><div class="flex"><span data-bind="text: scheduleName"></span></div></a></td>
                            <td data-bind=" if: template"><div class="flex"><span data-bind="text: template.name"></span></div></td>
                            <td data-bind="event: { click: $parent.viewNewsletterInteractionEmail }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewNewsletterInteractionEmail }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div> 
        `);
    }

    protected initPartial() {

        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {

        return "newsletterInteractionEmailList_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected buildViewModel(): any {

        let self = this
        return {
            newsletterInteractionEmails: ko.observableArray([]),
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("dateUpdated_ASC"),
            eventLabels: {},
            scheduleLabels: {},
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_interaction_emails'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewNewsletterInteractionEmail: (data, event) => {
                self.viewNewsletterInteractionEmail(data.id, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickDeactivate: (data, event) => {
                return self.onClickDeactivate(data, event);
            },
        }
    }

    public getViewModelForRequest(): any {

        return {
            filters: {
                keyword: this.getTemplateViewModel().filter.filterKeyword
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
        }
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setEvents(events) {
        const labels = {};
        events.forEach((event) => labels[event.reference] = event.name);
        this.getTemplateViewModel().eventLabels = labels;
    }

    public setSchedules(schedules) {
        const labels = {};
        schedules.forEach((schedule) => labels[schedule.reference] = schedule.name);
        this.getTemplateViewModel().scheduleLabels = labels;
    }

    protected viewNewsletterInteractionEmail(data, event) {

        this.caller.viewNewsletterInteractionEmail(data)
    }

    protected onClickReorder(value, data, event) {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.newsletterInteractionMailListReorder();
    }

    public onClickAdd() {

        this.caller.addNewsletterInteractionEmail()
    }

    protected setNewsletterInteractionEmails(newsletterInteractionEmails, brandId) {

        newsletterInteractionEmails.forEach((nie) => {
            nie['emakiView'] = '/brand/' + brandId + '/newsletter/interaction-emails/view/' + nie.id + '/';
            nie['eventName'] = this.getTemplateViewModel().eventLabels[nie.eventReference] || nie.eventReference || '';
            const scheduleReference = nie.eventSchedule || 'immediately_after_event';
            nie['scheduleName'] = this.getTemplateViewModel().scheduleLabels[scheduleReference] || 'Immediately after event';
            nie['isActive'] = nie.isActive === true || nie.isActive === 1 || nie.isActive === '1';
            nie['statusLabel'] = nie.isActive ? 'Active' : 'Inactive';
        });
        this.getTemplateViewModel().newsletterInteractionEmails(newsletterInteractionEmails)
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    protected onClickDeactivate(data, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.caller.deactivateNewsletterInteractionEmail(data.id);
        return false;
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterInteractionEmailList_template.ts